import { render, staticRenderFns } from "./InvestorForm.vue?vue&type=template&id=793515fc&lang=pug&"
import script from "./InvestorForm.vue?vue&type=script&lang=js&"
export * from "./InvestorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports